import { MessageCircleQuestion } from "lucide-react";
import { Badge } from "@/components/ui/badge";
import { Card, CardContent, CardHeader, CardTitle } from "@/components/ui/card";
import { useGuidanceRequests } from "@/hooks/use-audits";
import { AUDIT_STATUS_LABELS } from "@/lib/audit-status";
import { formatDateTime } from "@/lib/format";

interface GuidanceRequestLogProps {
  auditId: string;
}

export function GuidanceRequestLog({ auditId }: GuidanceRequestLogProps) {
  const { data: entries = [] } = useGuidanceRequests(auditId, true);
  if (entries.length === 0) return null;

  return (
    <Card>
      <CardHeader>
        <CardTitle className="text-base flex items-center gap-2">
          <MessageCircleQuestion className="h-4 w-4" />
          Guidance Requests
          <Badge variant="secondary">{entries.length}</Badge>
        </CardTitle>
      </CardHeader>
      <CardContent className="space-y-3">
        {entries.map((entry) => (
          <details key={entry.id} className="rounded-md border px-3 py-2 text-sm">
            <summary className="cursor-pointer">
              <span className="font-medium">{formatDateTime(entry.createdAt)}</span>
              <span className="text-muted-foreground">
                {" "}
                · {entry.requestedByName ?? "Unknown"}
                {entry.hours !== null && ` · ${entry.hours} hrs`} ·{" "}
                {AUDIT_STATUS_LABELS[entry.statusAtRequest] ?? entry.statusAtRequest}
              </span>
              {!entry.slackDelivered && (
                <Badge variant="destructive" className="ml-2">
                  Slack failed
                </Badge>
              )}
            </summary>
            <p className="mt-2 whitespace-pre-wrap text-muted-foreground">{entry.message}</p>
          </details>
        ))}
      </CardContent>
    </Card>
  );
}
